import { jsx as _jsx } from "react/jsx-runtime";
import { useStyles } from '@kubit/web-ui-components/hooks/useStyles';
import { ThirdPartyAnimation } from '@kubit/web-ui-components/thirdPartyAnimation';
import { STYLES_NAME } from '../../constants/stylesName/stylesName';
import { ThirdPartyAnimationSizesType } from '../../designSystem/reloaded/commons/components/thirdPartyAnimation/variants';
/**
 * Loader component that wraps the `ThirdPartyAnimation` component, allowing for additional customization
 * through `size`, `height`, and `width` properties.
 *
 * @param props - Loader properties including optional size, height, width, and any other props supported by `ThirdPartyAnimation`.
 * @returns The `ThirdPartyAnimation` component with applied customizations.
 */
export const Loader = ({ size, ...props }) => {
    const sizeMeasures = useStyles(STYLES_NAME.LOADER_SIZE, size || ThirdPartyAnimationSizesType.LARGE);
    const width = props.width || sizeMeasures.width;
    const height = props.height || sizeMeasures.height;
    const ariaLabel = props['aria-label'] || '';
    return (_jsx(ThirdPartyAnimation, { ...props, "aria-label": ariaLabel, dataTestId: "loader", height: height, width: width }));
};
//# sourceMappingURL=loader.js.map